<template>
  <div id="app-carousel">
    <div class="carousel">
      <div class="carousel-box">
        <el-carousel height="600px">
          <el-carousel-item v-for="(item,index) in adsList" :key="index">
            <!-- <img v-lazy="item.pic_full_path" alt @click="goDetails(item)"> -->
            <div
              class="img-box"
              :style="{background: 'url(' + item.pic_full_path + ')no-repeat center top', backgroundSize:'cover'}"
              @click="goDetails(item)"
            ></div>
            <!-- <img v-lazy="item.pic_full_path" v-if="item==2" alt @click="goDetails(item)">
            <img src="../../assets/images/carousel.png" v-if="item==3" alt @click="goDetails(item)">
            <img src="../../assets/images/bannar_1.png" v-if="item==4" alt @click="goDetails(item)">-->
          </el-carousel-item>
        </el-carousel>
      </div>
      <!-- <div class="carousel-info animated fadeInUpBig">
        <ul>
          <li>
            <p>目标筹款/元</p>
            <h3>3,300,000</h3>
          </li>
          <li>
            <p>已经筹款/元</p>
            <h3>1,901,758.07</h3>
          </li>
          <li>
            <p>捐款人次/次</p>
            <h3>24,835</h3>
          </li>
          <button>我要捐赠</button>
        </ul>
      </div>-->
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      adsList: []
    };
  },
  methods: {
    goDetails(item) {
      //轮播图跳转
      if (item.ads_type == 1) {
        //项目
        this.$router.push({
          name: "projectDetails",
          query: { id: item.action_id }
        });
      } else if (item.ads_type == 2) {
        //新闻
        this.$router.push({
          name: "pubDetails",
          query: { id: item.action_id }
        });
      } else if (item.ads_url) {
        window.open(item.ads_url);
      }
    }
  },
  created() {
    this.$db.post(this.$db.config.getBannerDataUrl, {}).then(res => {
      if (res.code == 200) {
        this.adsList = res.data;
      }
    });
  }
};
</script>
<style lang="scss" scoped>
#app-carousel {
  width: 100%;
}
.carousel {
  width: 100%;
  position: relative;
  .carousel-box {
    width: 100%;
    margin-bottom: 20px;
  }
  .carousel-info {
    width: 1300px;
    height: 160px;
    background-color: #ffffff;
    box-shadow: 1px 2px 38px 0px rgba(9, 1, 4, 0.15);
    z-index: 9999;
    position: relative;
    bottom: 56px;
    margin: 0 auto;
    > ul {
      display: flex;
      padding: 0 80px;
      justify-content: space-between;
      > li {
        list-style: none;
        margin: 50px 0;
        padding-right: 100px;
        border-right: 1px solid #eee;
        > p {
          font-size: 16px;
          color: #999;
          margin-bottom: 5px;
        }
        > h3 {
          font-size: 30px;
          color: #333;
        }
      }
      > li:last-child {
        border-right: none;
      }
      > button {
        margin: 0;
        padding: 0;
        border: none;
        outline: none;
        font-size: 20px;
        width: 141px;
        height: 54px;
        background-color: #c30d23;
        box-shadow: 2px 3px 10px 0px rgba(9, 1, 4, 0.21);
        border-radius: 6px;
        color: #fff;
        margin-top: 53px;
        cursor: pointer;
      }
    }
  }
}
.carousel-box /deep/ .el-carousel__indicators {
  bottom: 30px;
}
.carousel-box /deep/ .el-carousel__button {
  width: 10px;
  height: 10px;
  background-color: #ffffff;
  opacity: 0.5;
  border-radius: 50%;
}
.carousel-box /deep/ .el-carousel__indicator.is-active button {
  background-color: #b60205;
  opacity: 1;
}
.carousel-box /deep/ .el-carousel__item > .img-box {
  width: 100%;
  height: 100%;
  min-width: 1300px;
}
</style>




// WEBPACK FOOTER //
// src/components/Home/home_carousel.vue